import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Callout, Button, FormGroup, Dialog, Classes, Tag, Card, H5, OverlayToaster, Position, InputGroup, Switch, Icon, MenuItem } from '@blueprintjs/core';
import { Select } from "@blueprintjs/select";

import {
  bonitickAuthenticatedPostFetchWithResult,
  bonitickAuthenticatedPatchFetch,
} from '../../../src/utils/BonitickAuthenticatedFetch';

import SiteParkListSelect from '../Structure/SiteSelector';
import { getDiscountLookup } from './lookup';
import i18n from 'i18next';

let SELECT_TYPE_OPTIONS = [];



class Bonification extends React.Component {
  constructor(props) {
    super(props);
    SELECT_TYPE_OPTIONS = [
      { id: 'value', label: 'bonitick_value', desc: 'bonitick_value_desc', symbol: '€' },
      { id: 'time_start', label: 'bonitick_time_start', desc: 'bonitick_time_start_desc', symbol: 'min' },
      { id: 'time', label: 'bonitick_time_end', desc: 'bonitick_time_end_desc', symbol: 'min' },
      { id: 'percent', label: 'bonitick_percent', desc: 'bonitick_percent_desc', symbol: '%' },
      { id: 'rate', label: 'bonitick_rate', desc: 'bonitick_rate_desc', symbol: '' },
      { id: 'external_value', label: 'bonitick_external_value', desc: 'bonitick_external_value_desc', symbol: '' }
    ];

    this.state = {
      discounts: [],
      parks: props.parks,
      sites: props.sites,
      id: undefined,
      isApplicable: true,
      label: undefined,
      description: undefined,
      type: 'value',
      value: undefined,
      currency: undefined,
      idPark: undefined,
      idCountry: undefined,
      input_parks: [],
    };
  }

  async updateCard() {
    const discounts = await getDiscountLookup()
    this.setState({ discounts });
    return discounts;
  }
  async add2Discount(data, id) {
    const discounts = await getDiscountLookup()
    discounts.push({ ...data, id });
    localStorage.setItem("discountLookup", JSON.stringify(discounts));
    this.setState({ discounts });
    return discounts;
  }

  async updateDiscountLookup(item) {
    const discounts = await getDiscountLookup();
    const theItem = discounts.findIndex(d => d.id === item.id);
    if (theItem !== -1)
      discounts[theItem] = { ...discounts[theItem], ...item };
    localStorage.setItem("discountLookup", JSON.stringify(discounts));
    this.setState({ discounts });
    return discounts;
  }

  setCurrency() {
    if (this.state.type === 'time' || this.state.type === 'time_start' || this.state.type === 'time_end') {
      return 'min';
    }
    else if (this.state.type === 'percent') {
      return '%';
    }
    else if (this.state.type === 'rate') {
      return '';
    }
    else {
      return 'euro';
    }
  }

  disableButton() {
    const { label, description, value, type, input_parks } = this.state;
    if (type === 'external_value')
      return !(label && description && type && input_parks?.length > 0);
    else
      return !(label && description && value && value > 0 && type && input_parks?.length > 0);
  }

  async componentDidMount() {
    await this.updateCard();
  }

  toasterRef = React.createRef();

  showToaster(msg, intent, icon) {
    this.toasterRef.current?.show({
      message: msg,
      intent: intent,
      icon: icon
    });
  }

  getSelectTypeption() {
    const tab = [];
    SELECT_TYPE_OPTIONS.forEach((option, index) => {
      if (option.id === this.state.type) {
        tab.push(<p key={index} ><Trans>{option.desc}</Trans></p>);
      }
    });
    return tab;
  }

  getListOfValidKey(item) {
    const res = item.map(i => {
      if (i.key)
        return i.key;
      else
        return `${i.server.infoSup.publicId.site}-${i.id}`;
    });
    return res.join(',');
  }

  getParksFromValidKey(item) {
    const listSrvPark = item.split(',')
    const ret = []
    listSrvPark.forEach(l => {
      const ids = l.split('-');
      const siteId = Number(ids[0]);
      const parkId = Number(ids[1]);
      this.state.parks.forEach(p => {
        if (p.id === parkId && Number(p.server.infoSup.publicId.site) === siteId) {
          ret.push(p);
        }
      })
    })
    return ret;
  }


  render() {
    return (
      <div>
        <Callout title={<Trans>bonification</Trans>} intent="success" icon="tag">
          <Button icon="add" text={i18n.t("add")} onClick={() => this.setState({ AddBonification: true, input_parks: [] })} />
          <Dialog
            style={{ transition: 'none' }}
            isOpen={this.state.AddBonification}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            onClose={() => this.setState({ AddBonification: false })}
            title={<Trans>add a bonification</Trans>}
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup label={<Trans>label</Trans>} labelFor="input_name">
                <InputGroup
                  id="input_name"
                  onChange={(ti) => this.setState({ label: ti.target.value })}
                  leftIcon="label"
                  large={true}
                  placeholder="Ma bonification"
                />
              </FormGroup>

              <FormGroup label={<Trans>description</Trans>} labelFor='input_description'>
                <InputGroup
                  id="input_description"
                  onChange={(ti) => this.setState({ description: ti.target.value })}
                  leftIcon="label"
                  large={true}
                />
              </FormGroup>


              <FormGroup label={<Trans>applicable</Trans>} labelFor="input_applicable">
                <Switch
                  id="input_applicable"
                  checked={this.state.isApplicable}
                  onChange={(ti) => this.setState({ isApplicable: ti.target.checked })}
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>type</Trans>} labelFor="input_type">
                <Select items={SELECT_TYPE_OPTIONS}
                  itemPredicate={(query, item) => i18n.t(item.label).toLowerCase().indexOf(query.toLowerCase()) >= 0}
                  itemRenderer={(item, { handleClick, modifiers }) => {
                    if (!modifiers.matchesPredicate) {
                      return null;
                    }
                    return (
                      <MenuItem active={this.state.type === item.id} key={item.id} onClick={handleClick} text={i18n.t(item.label)} />

                    );
                  }}
                  noResults={< option disabled={true} value={undefined} > No results.</option>}
                  onItemSelect={(ti) => this.setState({ type: ti.id })}
                  popoverProps={{ minimal: true }}
                  filterable={true}
                >
                  <Button text={i18n.t(SELECT_TYPE_OPTIONS.filter((option) => option.id === this.state.type)[0]?.label)} rightIcon="double-caret-vertical" />
                </Select>
                <br />
                {this.getSelectTypeption()}
              </FormGroup>

              {this.state.type !== 'external_value' && (
                <FormGroup label={this.state.type !== 'external_value'?<Trans>value</Trans>:<Trans>tarif code</Trans>} labelFor="input_value">
                  <InputGroup
                    id="input_value"
                    onChange={(ti) => this.setState({ value: ti.target.value })}
                    leftIcon={this.state.type === 'percent' ? 'percentage' : 'tag'}
                    large={true}
                    type="number"
                    placeholder="2"
                  />
                </FormGroup>)}

              <FormGroup label={<Trans>parks</Trans>} labelFor="input_site">
                <SiteParkListSelect id="input_parks"
                  label={<Trans>add a park</Trans>}
                  onSelect={(siteId, site) => this.setState({ input_parks: [...this.state.input_parks, site] })}
                  selected={this.state.input_parks}
                />
                <div className="flexbox-left">
                  {
                    this.state.input_parks?.length > 0 &&
                    this.state.input_parks?.map((site, index) => (
                      <Tag
                        key={index}
                        onRemove={() => this.setState({ input_parks: this.state.input_parks?.filter((i) => i.pk !== site.pk) })}
                      >{site.name.includes("-") ? site.name : `${site.server.name}-${site.name}`}
                      </Tag>
                    ))}
                </div>
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    text={<Trans>Add</Trans>}
                    intent="primary"
                    icon="add"
                    disabled={this.disableButton()}
                    onClick={() => {
                      bonitickAuthenticatedPostFetchWithResult(
                        '/bonification',
                        {
                          label: this.state.label,
                          description: this.state.description,
                          isApplicable: this.state.isApplicable,
                          type: this.state.type,
                          value: this.state.type !== 'external_value' ? this.state.value : 1,
                          currency: this.setCurrency(),
                          listValidKey: this.getListOfValidKey(this.state.input_parks),
                        }, async (res, data) => {
                          await this.add2Discount({
                            label: this.state.label,
                            description: this.state.description,
                            isApplicable: this.state.isApplicable,
                            type: this.state.type,
                            value: this.state.type !== 'external_value' ? this.state.value : 1,
                            currency: this.setCurrency(),
                            listValidKey: this.getListOfValidKey(this.state.input_parks),
                          }, data.discount.id);
                          this.setState({ AddBonification: false });
                          this.showToaster("Bonification added", "success", "tick-circle");
                        }, (_e) => {
                          this.showToaster(i18n.t(`label must be unique, please verify`), "danger", "error");
                        });
                    }}
                  />
                  <Button
                    text={<Trans>Cancel</Trans>}
                    intent="warning"
                    icon="undo"
                    style={{ marginLeft: '1em' }}
                    onClick={() => this.setState({ AddBonification: false })}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>



          {/* EDIT BONIFICATION */}
          <Dialog
            style={{ transition: 'none' }}
            isOpen={this.state.isOpen}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            onClose={() => this.setState({ isOpen: false })}
            title={<Trans>Update bonification</Trans>}
          >
            <div className={Classes.DIALOG_BODY}>

              <FormGroup label={<Trans>label</Trans>} labelFor="input_label">
                <InputGroup
                  id="input_label"
                  onChange={(ti) => this.setState({ label: ti.target.value })}
                  leftIcon="label"
                  large={true}
                  value={this.state.label}
                />
              </FormGroup>

              <FormGroup label={<Trans>description</Trans>} labelFor='input_desc'>
                <InputGroup
                  id="input_desc"
                  onChange={(ti) => this.setState({ description: ti.target.value })}
                  leftIcon="label"
                  large={true}
                  value={this.state.description}
                />
              </FormGroup>

              <FormGroup label={<Trans>applicable</Trans>} labelFor="input_applicable">
                <Switch
                  id="input_applicable"
                  checked={this.state.isApplicable}
                  onChange={(ti) => this.setState({ isApplicable: ti.target.checked })}
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>type</Trans>} labelFor="input_type">
                <Select items={SELECT_TYPE_OPTIONS}
                  itemPredicate={(query, item) => i18n.t(item.label).toLowerCase().indexOf(query.toLowerCase()) >= 0}
                  itemRenderer={(item, { handleClick, modifiers }) => {
                    if (!modifiers.matchesPredicate) {
                      return null;
                    }
                    return (
                      <MenuItem active={this.state.type === item.id} key={item.id} onClick={handleClick} text={i18n.t(item.label)} />

                    );
                  }}
                  noResults={< option disabled={true} value={undefined} > No results.</option>}
                  onItemSelect={(ti) => this.setState({ type: ti.id })}
                  popoverProps={{ minimal: true }}
                  filterable={true}
                >
                  <Button text={i18n.t(SELECT_TYPE_OPTIONS.filter((option) => option.id === this.state.type)[0]?.label)} rightIcon="double-caret-vertical" />
                </Select>
                <br />
                {this.getSelectTypeption()}
              </FormGroup>

              {this.state.type !== 'external_value' && (
                <FormGroup label={<Trans>value</Trans>} labelFor="input_value">
                  <InputGroup
                    id="input_value"
                    onChange={(ti) => this.setState({ value: ti.target.value })}
                    leftIcon={this.state.type === 'percent' ? 'percentage' : 'tag'}
                    large={true}
                    value={this.state.value}
                    type="number"
                  />
                </FormGroup>)}


              <FormGroup label={<Trans>parks</Trans>} labelFor="input_site">
                <SiteParkListSelect id="input_parks"
                  label={<Trans>add a park</Trans>}
                  onSelect={(siteId, site) => this.setState({ input_parks: [...this.state.input_parks, site] })}
                  selected={this.state.input_parks}
                />
                <div className="flexbox-left">
                  {
                    this.state.input_parks?.length > 0 &&
                    this.state.input_parks?.map((site, index) => (
                      <Tag
                        key={index}
                        onRemove={() => this.setState({ input_parks: this.state.input_parks?.filter((i) => i.pk !== site.pk) })}
                      >
                        {site.name.includes("-") ? site.name : `${site.server.name}-${site.name}`}
                      </Tag>
                    ))
                  }
                </div>
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    text={<Trans>edit</Trans>}
                    intent="primary"
                    type="submit"
                    icon="edit"
                    disabled={this.disableButton()}
                    onClick={() => {
                      bonitickAuthenticatedPatchFetch(
                        '/bonification',
                        {
                          id: this.state.id,
                          label: this.state.label,
                          description: this.state.description,
                          isApplicable: this.state.isApplicable,
                          type: this.state.type,
                          value: this.state.value !== 'external_value' ? this.state.value : '0',
                          currency: this.setCurrency(),
                          listValidKey: this.getListOfValidKey(this.state.input_parks),

                        }, async () => {
                          this.updateDiscountLookup({
                            id: this.state.id,
                            label: this.state.label,
                            description: this.state.description,
                            isApplicable: this.state.isApplicable,
                            type: this.state.type,
                            value: this.state.value !== 'external_value' ? this.state.value : '0',
                            currency: this.setCurrency(),
                            listValidKey: this.getListOfValidKey(this.state.input_parks),

                          });
                          this.setState({ isOpen: false });
                          this.showToaster("Bonification updated", "success", "tick-circle");
                        },
                        (e) => { this.showToaster(`Error : ${e?.message}`, "danger", "error") });
                    }}
                  />

                  <Button
                    text={<Trans>cancel</Trans>}
                    intent="warning"
                    icon="undo"
                    style={{ marginLeft: '5px' }}
                    onClick={() => this.setState({ isOpen: false })}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog >

          <div className="flexbox-left">
            {this.state.discounts?.map((discount, index) => {
              return (
                <Card
                  key={index}
                  interactive={true}
                  id={discount.id}
                  style={{ marginRight: "5px" }}
                  onClick={() =>
                    this.setState({
                      isOpen: true,
                      id: discount.id,
                      label: discount.label,
                      description: discount.description,
                      isApplicable: discount.isApplicable,
                      type: discount.type,
                      value: discount.value,
                      currency: discount.currency,
                      input_parks: this.getParksFromValidKey(discount.listValidKey),
                    })
                  }
                >
                  <div>
                    <H5
                      style={{
                        color: discount.isApplicable ? '#1c6e42' : 'gray',
                      }}
                      className="flexbox-center"
                    >{discount.label}</H5>
                    {(discount.type !== 'external_value')?
                    <p className="flexbox-center" >{discount.value} {SELECT_TYPE_OPTIONS.filter((option) => option.id === discount.type)[0]?.symbol}</p>
                    :<p>&nbsp;</p>}
                    <p><Icon icon="known-vehicle" /> <Trans>park</Trans> : {this.getParksFromValidKey(discount.listValidKey).map((id) => {
                      return `${id.server.name}-${id.name}`;
                    }
                    ).join(', ')}</p>
                  </div>
                </Card>
              );
            })}
          </div>
          <OverlayToaster className={Classes.TOAST_CONTAINER} usePortal={true} ref={this.toasterRef} position={Position.RIGHT_BOTTOM} />
        </Callout >
      </div >
    );
  }
}



export default withTranslation()(Bonification);
